export { default } from "ember-stereo/helpers/sound-duration";
